import { Capacitor } from '@capacitor/core';

/**
 * Mobile web form scroll handler.
 * On mobile browsers (non-Capacitor), scrolls focused inputs into view
 * after the keyboard opens, so the active field is never hidden.
 */
export function initMobileFormScroll(): void {
  if (Capacitor.isNativePlatform()) return;

  const isMobile = () => window.innerWidth <= 768;

  document.addEventListener(
    'focusin',
    (e) => {
      if (!isMobile()) return;
      const el = e.target as HTMLElement;
      if (!isInputLike(el)) return;

      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    },
    { passive: true },
  );
}

function isInputLike(el: HTMLElement): boolean {
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}
